export default {"src":"/_next/static/media/palette-own.45f629f5.svg","height":100,"width":100};